import React from 'react';
import { ArcBox, ArcStack, ArcText } from '@src/core/ui';
import { MissionTemplateEntity } from '@src/features/order/entities';

interface MissionTemplateCardProps {
  template: MissionTemplateEntity;
  isSelected: boolean;
  onClick: () => void;
}

const locationAddress = (template: MissionTemplateEntity) =>
  template.destinationLocation?.address
  || template.takeoffLocation?.address
  || 'Unknown destination';

const MissionTemplateCard: React.FC<MissionTemplateCardProps> = (props) => {
  const { template, isSelected, onClick } = props;

  return (
    <ArcBox
      p={1.5}
      width='100%'
      bgcolor='grey.900'
      borderRadius={1}
      onClick={onClick}
      sx={{
        cursor: 'pointer',
        '&:hover': { bgcolor: 'grey.800' },
        border: '1px solid',
        borderColor: isSelected ? 'brand.main' : 'grey.900',
      }}
    >
      <ArcStack direction='column' spacing={1}>
        <ArcText.h6 color='common.white' fontSize={14} fontWeight={600}>
          {template.name}
        </ArcText.h6>
        <ArcText
          color='text.secondary'
          fontSize={12}
          sx={{
            textOverflow: 'ellipsis',
            display: '-webkit-box',
            WebkitLineClamp: 2,
            WebkitBoxOrient: 'vertical',
            overflow: 'hidden',
          }}
        >
          {locationAddress(template)}
        </ArcText>
      </ArcStack>
    </ArcBox>
  );
};

export default MissionTemplateCard;
